<template>
  <div id="sequence_email_analytics" class="flex flex-col gap-2">
    <EmailAnalyticsGrid />
    <EmailEngagementActivityGraph />
    <EmailFunnelGraph />
  </div>
</template>

<script setup>
import EmailFunnelGraph from "@/src/views/analytics/v2/sequence_analytics/email/EmailFunnelGraph.vue";
import EmailAnalyticsGrid from "@/src/views/analytics/v2/sequence_analytics/email/EmailAnalyticsGrid.vue";
import EmailEngagementActivityGraph from "@/src/views/analytics/v2/sequence_analytics/email/EmailEngagementActivityGraph.vue";
</script>
